(function () {
  function initFeaturedSlider(slider) {
    const container =
      slider.closest(".featured-container") || slider.parentElement;
    const header = container?.previousElementSibling;
    const prevBtn = header?.querySelector(".prev");
    const nextBtn = header?.querySelector(".next");

    const items = slider.querySelectorAll(
      ".product-card-item, .collection-card-item"
    );
    if (!items.length) return;

    const gap = () => parseFloat(getComputedStyle(slider).gap) || 10;
    const cardWidth = () => items[0].offsetWidth + gap();
    const maxScroll = () =>
      Math.max(0, slider.scrollWidth - container.clientWidth);

    // --- Prevent image dragging ---
    slider.querySelectorAll("img").forEach((img) => {
      img.setAttribute("draggable", "false");
      img.style.userSelect = "none";
      img.style.webkitUserDrag = "none";
      img.addEventListener("dragstart", (e) => e.preventDefault());
      img.addEventListener("mousedown", (e) => e.preventDefault());
    });

    // --- Buttons ---
    const scrollByCard = (dir) =>
      container.scrollBy({ left: dir * cardWidth(), behavior: "smooth" });

    prevBtn?.addEventListener("click", () => scrollByCard(-1));
    nextBtn?.addEventListener("click", () => scrollByCard(1));

    // --- Button state ---
    // function updateButtons() {
    //   if (!prevBtn || !nextBtn) return;
    //   const eps = 2;
    //   prevBtn.disabled = container.scrollLeft <= eps;
    //   nextBtn.disabled = container.scrollLeft >= maxScroll() - eps;
    // }

    // --- Mouse drag only (desktop) ---
    function enableDesktopDrag() {
      let startX = 0;
      let startScrollLeft = 0;
      let moved = false;
      const threshold = 6;

      const onDown = (e) => {
        if (e.button !== 0) return;
        startX = e.clientX;
        startScrollLeft = container.scrollLeft;
        moved = false;
        slider.classList.add("dragging");

        const link = e.target.closest("a");
        if (link) link.dataset.dragging = "false";

        const onMove = (ev) => {
          const dx = ev.clientX - startX;
          if (Math.abs(dx) > threshold) {
            moved = true;
            container.scrollLeft = startScrollLeft - dx;
            if (link) link.dataset.dragging = "true";
          }
        };

        const onUp = () => {
          document.removeEventListener("mousemove", onMove);
          document.removeEventListener("mouseup", onUp);
          slider.classList.remove("dragging");

          if (link) setTimeout(() => delete link.dataset.dragging, 100);
          // updateButtons();
        };

        document.addEventListener("mousemove", onMove);
        document.addEventListener("mouseup", onUp);
      };

      slider.addEventListener("mousedown", onDown);

      // prevent click when dragging
      slider.addEventListener("click", (e) => {
        const link = e.target.closest("a");
        if (link && link.dataset.dragging === "true") {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      });

      return () => {
        slider.removeEventListener("mousedown", onDown);
      };
    }

    // --- Responsive behavior ---
    let cleanupDrag = null;
    const handleResize = () => {
      if (window.innerWidth >= 1000) {
        if (!cleanupDrag) cleanupDrag = enableDesktopDrag();
      } else {
        if (cleanupDrag) {
          cleanupDrag();
          cleanupDrag = null;
        }
      }
      // updateButtons();
    };

    window.addEventListener("resize", handleResize);
    // container.addEventListener("scroll", updateButtons, { passive: true });
    // new ResizeObserver(updateButtons).observe(container);

    handleResize();
  }

  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll(".featured-container")
      .forEach(initFeaturedSlider);
  });

  window.initFeaturedSlider = initFeaturedSlider;
})();
